// extracted by mini-css-extract-plugin
module.exports = {"posts":"PostsList_posts__lUaYM","pagination":"PostsList_pagination___9Lrv","noPagination":"PostsList_noPagination__ROymJ"};